var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDaOutline = function SvgDaOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "*{vector-effect:non-scaling-stroke}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "currentColor",
    d: "M12 22.909c6.026 0 10.91-4.884 10.91-10.91 0-6.024-4.884-10.908-10.91-10.908C5.977 1.09 1.093 5.975 1.093 12S5.976 22.909 12 22.909Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.548 9H7v6h2.548c1.639 0 2.887-1.303 2.887-3s-1.248-3-2.887-3m0 4.68h-1.19v-3.36h1.19c.934 0 1.58.651 1.58 1.68s-.646 1.68-1.58 1.68M16.514 15H18l-1.936-6H14.33l-1.936 6h1.486l.272-.943h2.09zm-1.979-2.229.663-2.271.662 2.271z"
  })));
};
export default SvgDaOutline;